import { RouteObject } from "react-router";

import { Authenticate } from "@pages/login/Authenticate/Authenticate.page";
import { Invitation } from "@pages/login/Invitation/Invitation.page";
import { Login } from "@pages/login/Login/Login.page";
import { routes } from "@pages/routes";

import { AuthOrganizations } from "./AuthOrganizations/AuthOrganizations";
import { CreateAuthOrganization } from "./CreateAuthOrganization/CreateAuthOrganization";
import { EmailRequestPage } from "./EmailRequest/EmailRequest.page";

export const loginRoutes = [
  {
    path: routes.login.index.$path(),
    Component: Login,
  },
  {
    path: routes.login.authenticate.$path(),
    Component: Authenticate,
  },
  {
    path: routes.login.invitation.$path(),
    Component: Invitation,
  },
  {
    path: routes.login.createOrganization.$path(),
    Component: CreateAuthOrganization,
  },
  {
    path: routes.login.organizations.$path(),
    Component: AuthOrganizations,
  },
  {
    path: routes.login.emailRequest.$path(),
    Component: EmailRequestPage,
  },
] satisfies RouteObject[];
